var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationGreyRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.00031C13.9326 5.95191 11.9302 6.72437 10.4309 8.14868C8.93168 9.57298 8.05761 11.5332 8 13.6003C8 18.6803 13.91 24.7403 14.59 25.4103C14.9647 25.7828 15.4716 25.9919 16 25.9919C16.5284 25.9919 17.0353 25.7828 17.41 25.4103C18.09 24.7403 24 18.6803 24 13.6003C23.9424 11.5332 23.0683 9.57298 21.5691 8.14868C20.0698 6.72437 18.0674 5.95191 16 6.00031ZM16 17.0003C15.4067 17.0003 14.8266 16.8244 14.3333 16.4947C13.8399 16.1651 13.4554 15.6965 13.2284 15.1484C13.0013 14.6002 12.9419 13.997 13.0576 13.415C13.1734 12.8331 13.4591 12.2986 13.8787 11.879C14.2982 11.4594 14.8328 11.1737 15.4147 11.058C15.9967 10.9422 16.5999 11.0016 17.1481 11.2287C17.6962 11.4557 18.1648 11.8403 18.4944 12.3336C18.8241 12.827 19 13.407 19 14.0003C19 14.796 18.6839 15.559 18.1213 16.1216C17.5587 16.6842 16.7956 17.0003 16 17.0003Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationGreyRound);
export default __webpack_public_path__ + "static/media/ic-location-grey-round.9d42250c6110f536d2eba99db65e697e.svg";
export { ForwardRef as ReactComponent };